module.exports = __webpack_public_path__ + "static/bgk-c8905dc97cd47491e7e9f6b75645c84d.jpg";